


















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { MobileGetter, Testimonial } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapState('premiumTestimonials', {
      premiumTestimonials: ({ items }: { items: Testimonial[] }) => items,
    }),
  },
})
export default class GiftReviews extends Vue {
  private readonly isMobile!: MobileGetter;
}
